import fahrzeugtyp from '@ahd/shared/maps/fahrzeugtyp';
import { getActivePortals, getFirma4Id, getIdFirma, getMwSt, getStandorteForSelect } from '../_tools/Session';
import { getFieldFromArray } from '../_tools/Texte';
import { checkUndefinedNullOrEmpty, checkUndefinedOrNull } from '../_tools/Tools';
import { getVertrag } from '../_tools/Vertrag';
import { effizienzSteps } from '../components/effizienz';
import Iconify from '../components/iconify/component';
import { type IconifyProps } from '../components/iconify/types';
import { type CustomTheme } from '../provider/ThemeProvider';
import sIntAIPLevel from './s_int_AIPLevel';
import sIntAktivStatus from './s_int_aktivStatus';
import sIntAufbau from './s_int_aufbau';
import sIntExportStatus from './s_int_exportStatus';
import sIntHereinnahme from './s_int_hereinnahme';
import sIntKraftstoff from './s_int_kraftstoff';
import sIntMotor from './s_int_motor';
import sIntPlakette from './s_int_plakette';
import sIntProblemlevel from './s_int_problemlevel';
import sIntReserviertStatus from './s_int_reserviertStatus';
import sIntSchadstoff from './s_int_schadstoff';
import sIntSiegel from './s_int_siegel';
import sIntSteuer from './s_int_steuer';
import sPortalId from './s_portalID';
import sVerwendung from './s_verwendung';

const sSpaltenFahrzeuglisteOld = (theme: CustomTheme, vertrage): any[] => [
    { title: 'Bild', group: 'Bilder', field: 'urThumb', loading: 'bild', sorting: false, noCSV: true, i: 'bild', style: { width: 100 }, customRender: true },
    { title: 'Bilderanzahl', group: 'Bilder', loading: 'XS', field: 'bildCount', i: 'bildCount', customRender: true },
    { title: 'Auftragsnummer', group: 'Fahrzeugdaten', loading: 'S', field: 'nr', i: 'auftragsnr' },
    { title: 'VIN', group: 'Fahrzeugdaten', loading: 'M', field: 'ch', i: 'vin' },
    { title: 'Fahrzeugstatus', group: 'Fahrzeugdaten', loading: 'S', field: 'st', i: 'status' },
    { title: 'Fahrzeugtyp', group: 'Fahrzeugdaten', loading: 'L', field: 'tp', i: 'typ', type: 'singleselect', data: fahrzeugtyp },
    { title: 'Ankaufart', group: 'Fahrzeugdaten', loading: 'S', field: 'herk', i: 'ankaufart', type: 'singleselect', data: sIntHereinnahme },
    { title: 'Hersteller', group: 'Fahrzeugdaten', loading: 'S', field: 'hs', i: 'hersteller' },
    {
        title: 'Modell',
        group: 'Fahrzeugdaten',
        loading: 'M',
        field: 'md',
        i: 'modell',
        render: (rowData) => (rowData.md ? (rowData.md.length > 30 ? rowData.md.substring(0, 27) + '...' : rowData.md) : ''),
    },
    { title: 'Ausführung', group: 'Fahrzeugdaten', loading: 'L', field: 'dsgn', i: 'ausfuhrung' },
    {
        title: 'Firma',
        group: 'Fahrzeugdaten',
        loading: 'L',
        field: 'se.i',
        i: 'firma',
        render: (rowData) =>
            !checkUndefinedOrNull(getFirma4Id(rowData.se && rowData.se.i))
                ? getFirma4Id(rowData.se && rowData.se.i).al
                    ? getFirma4Id(rowData.se && rowData.se.i).al
                    : getFirma4Id(rowData.se && rowData.se.i).n
                : '',
    },
    { title: 'Standort', group: 'Fahrzeugdaten', loading: 'L', field: 'so', i: 'standort', type: 'singleselect', data: getStandorteForSelect() },
    { title: 'Standortbemerkung', group: 'Fahrzeugdaten', loading: 'M', field: 'locTxt', i: 'standort' },
    { title: 'Standortwechsel', group: 'Fahrzeugdaten', loading: 'S', field: 'stat.sw', i: 'datumStandortwechsel', type: 'date' },
    { title: 'Parkplatz', group: 'Fahrzeugdaten', loading: 'S', field: 'snr', i: 'parkplatz' },
    { title: 'Aufbau', group: 'Fahrzeugdaten', loading: 'M', field: 'iab', i: 'aufbau', type: 'singleselect', data: sIntAufbau },
    { title: 'Motorart', group: 'Fahrzeugdaten', loading: 'M', field: 'imtr', i: 'motorart', type: 'singleselect', data: sIntMotor },
    {
        title: 'Leistung',
        group: 'Fahrzeugdaten',
        loading: 'M',
        field: 'pw',
        i: 'leistung',
        render: (rowData) => {
            const leistungKW = rowData.pw ? Math.round(rowData.pw) : rowData.leistungPS ? Math.round(rowData.leistungPS * 0.735) : 0;
            const leistungPS = rowData.leistungPS ? Math.round(rowData.leistungPS) : rowData.pw ? Math.round(rowData.pw * 1.36) : '-';
            return leistungKW + ' kW / ' + leistungPS + ' PS';
        },
    },
    { title: 'Erstzulassung', group: 'Fahrzeugdaten', loading: 'M', field: 'ez', i: 'ez', type: 'date' },
    { title: 'Laufleistung', group: 'Fahrzeugdaten', loading: 'S', field: 'km', i: 'km', einheit: 'km' },
    { title: 'Kennzeichen', group: 'Fahrzeugdaten', loading: 'S', field: 'knz', i: 'knz' },
    { title: 'Standtage I', group: 'Statistik', loading: 'S', field: 'stat.st1', i: 'standtage1', customRender: true },
    { title: 'Standtage gesamt', group: 'Statistik', loading: 'S', field: 'stat.st2', i: 'standtageGesamt', customRender: true },
    { title: 'Preistage', group: 'Statistik', loading: 'S', field: 'stat.pt', i: 'preistage', customRender: true },
    { title: 'Inventur', group: 'Statistik', loading: 'S', field: 'stat.dinv', i: 'inventur', type: 'date' },
    { title: 'Verfügbar ab', group: 'Statistik', loading: 'S', field: 'stat.verfugbar', i: 'verfugbarAb', type: 'date' },
    { title: 'Zugang geplant', group: 'Statistik', loading: 'S', field: 'stat.zg', i: 'zugangGeplant', type: 'date' },
    { title: 'Siegel', group: 'Fahrzeugdaten', loading: 'S', field: 'sg.i', i: 'siegel', type: 'singleselect', data: sIntSiegel },
    { title: 'Verwendung', group: 'Fahrzeugdaten', loading: 'S', field: 'v', type: 'singleselect', data: sVerwendung(getIdFirma() === 53880), i: 'verwendung' },
    { title: 'Warnungen', group: 'Fahrzeugdaten', loading: 'icon', field: 'warnings', type: 'singleselect', data: sIntProblemlevel, i: 'warnungen', customRender: true },
    { title: 'e-Preisschild', group: 'Fahrzeugdaten', loading: 'icon', field: 'aip', type: 'singleselect', data: sIntAIPLevel, i: 'preisschild', customRender: true },
    { title: 'Garantie', group: 'Fahrzeugdaten', loading: 'S', field: 'gar.g', i: 'garantie' },

    { title: 'Export', group: 'Export', loading: 'icon', field: 'export.exp', i: 'exportiert', type: 'singleselect', data: sIntExportStatus, customRender: true },
    ...getActivePortals()
        .map((portal) => {
            const name = getFieldFromArray(sPortalId, 't', portal, 'i', undefined) as string;
            const icon = getFieldFromArray(sPortalId, 'icon', portal, 'i', undefined) as IconifyProps;
            const zugang = (getFieldFromArray(sPortalId, 'et', portal, 'i', undefined) as string) || '';
            const group = (getFieldFromArray(sPortalId, 'group', portal, 'i', undefined) as string) || '';
            const groupSort = group.toLowerCase().includes('mobile.de')
                ? 'aaaaaa'
                : group.toLowerCase().includes('autoscout') || group.toLowerCase().includes('as24')
                  ? 'aaaaab'
                  : group.toLowerCase().includes('heycar')
                    ? 'aaaaac'
                    : group.toLowerCase().includes('gewato')
                      ? 'aaaaad'
                      : 'zzzzzzzzzz';
            return {
                iconTitle: (
                    <div style={{ lineHeight: 1, whiteSpace: 'pre-wrap' }}>
                        {!checkUndefinedNullOrEmpty(icon) ? <Iconify icon={icon} /> : <p style={{ marginBottom: icon ? 2 : 4 }}>{name}</p>}
                        <p style={{ margin: 0 }}>{zugang}</p>
                    </div>
                ),
                title: [name, zugang.replace('Zugang', 'Zg.')].join(' '),
                group: 'Export',
                groupSort: groupSort,
                loading: 'S',
                field: 'export.' + portal + '.exp',
                i: 'portal_' + portal,
                type: 'singleselect',
                data: sIntExportStatus,
                customRender: true,
            };
        })
        .sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
        .sort((a, b) => a.groupSort.toLowerCase().localeCompare(b.groupSort.toLowerCase())),

    { title: 'Reserviert', group: 'Fahrzeugdaten', loading: 'icon', field: 'isRes', i: 'reserviert', type: 'singleselect', data: sIntReserviertStatus, customRender: true },
    { title: 'Einkäufer', group: 'Fahrzeugdaten', loading: 'L', field: 'usr_e.n', i: 'einkaufer' },
    { title: 'Verkäufer', group: 'Fahrzeugdaten', loading: 'L', field: 'usr_v.n', i: 'verkaufer' },
    { title: 'Verkaufsdatum', group: 'Fahrzeugdaten', loading: 'S', field: 'dv', i: 'dateVerkauf', type: 'date' },
    // Leads
    { title: 'Offene Leads', group: 'Leads', loading: 'S', field: 'leads.offen', i: 'leadsOffen' },
    { title: 'Beendete Leads', group: 'Leads', loading: 'S', field: 'leads.beendet', i: 'leadsBeendet' },
    // Verbrauch
    { title: 'Kraftstoff', group: 'Verbrauch', loading: 'M', field: 'vb.iks', i: 'verbrauchKraftstoff', type: 'singleselect', data: sIntKraftstoff },
    {
        title: 'Verbrauch innerorts',
        group: 'Verbrauch',
        loading: 'M',
        field: 'vb.ei',
        i: 'verbrauchInner',
        render: (rowData) => {
            if (rowData.vb && rowData.vb.ei) {
                const stringBuilder = [];
                if (!rowData.vb.en) stringBuilder.push('ca.');
                stringBuilder.push(rowData.vb.ei.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
                stringBuilder.push(rowData.vb.iks === 18 ? 'kWh/100km' : 'l/100km');
                return stringBuilder.join(' ');
            }
        },
    },
    {
        title: 'Verbrauch außerorts',
        group: 'Verbrauch',
        loading: 'M',
        field: 'vb.eo',
        i: 'verbrauchAusser',
        render: (rowData) => {
            if (rowData.vb && rowData.vb.eo) {
                const stringBuilder = [];
                if (!rowData.vb.en) stringBuilder.push('ca.');
                stringBuilder.push(rowData.vb.eo.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
                stringBuilder.push(rowData.vb.iks === 18 ? 'kWh/100km' : 'l/100km');
                return stringBuilder.join(' ');
            }
        },
    },
    {
        title: 'Verbrauch kombiniert',
        group: 'Verbrauch',
        loading: 'M',
        field: 'vb.ec',
        i: 'verbrauchKombi',
        render: (rowData) => {
            if (rowData.vb && rowData.vb.ec) {
                const stringBuilder = [];
                if (!rowData.vb.en) stringBuilder.push('ca.');
                stringBuilder.push(rowData.vb.ec.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
                stringBuilder.push(rowData.vb.iks === 18 ? 'kWh/100km' : 'l/100km');
                return stringBuilder.join(' ');
            }
        },
    },
    {
        title: 'Emission',
        group: 'Verbrauch',
        loading: 'M',
        field: 'vb.em',
        i: 'verbrauchEmission',
        render: (rowData) => {
            if (rowData.vb && rowData.vb.em) {
                const stringBuilder = [];
                if (!rowData.vb.en) stringBuilder.push('ca.');
                stringBuilder.push(rowData.vb.em.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 }));
                stringBuilder.push('g/km');
                return stringBuilder.join(' ');
            }
        },
    },
    { title: 'Effizienz', group: 'Verbrauch', loading: 'M', field: 'vb.ief', i: 'verbrauchEffizienz', height: '1.25em', type: 'singleselect', data: effizienzSteps(false) },
    { title: 'Euronorm', group: 'Verbrauch', loading: 'M', field: 'vb.isn', i: 'verbrauchEuronorm', type: 'singleselect', data: sIntSchadstoff },
    { title: 'Plakette', group: 'Verbrauch', loading: 'M', field: 'vb.ipl', i: 'verbrauchPlakette', height: '2em', type: 'singleselect', data: sIntPlakette },
    { title: 'Jahressteuer', group: 'Verbrauch', loading: 'M', field: 'pr.jst', i: 'verbrauchJahressteuer', type: 'currency' },
    // Finanzierung
    { title: 'Laufzeit', group: 'Finanzierung', loading: 'S', field: 'fd.fin.lz', i: 'finanzierungLaufzeit', type: 'decimal', einheit: 'Monate' },
    { title: 'Anzahlung', group: 'Finanzierung', loading: 'S', field: 'fd.fin.az', i: 'finanzierungAnzahlung', type: 'currency' },
    { title: 'Rate', group: 'Finanzierung', loading: 'S', field: 'fd.fin.mr', i: 'finanzierungRate', type: 'currency' },
    { title: 'Schlussrate', group: 'Finanzierung', loading: 'S', field: 'fd.fin.sr', i: 'finanzierungSchlussrate', type: 'currency' },
    { title: 'Kilometer / Jahr', group: 'Finanzierung', loading: 'S', field: 'fd.fin.km', i: 'finanzierungKm', type: 'decimal', einheit: 'km' },
    { title: 'FD übertragen', group: 'Finanzierung', loading: 'icon', field: 'fd.fin.up', i: 'finanzierungUpload', type: 'singleselect', data: sIntAktivStatus },
    // Verkaufsverstärker
    {
        title: 'Aktionsfahrzeug',
        group: 'Aktionen Homepage',
        loading: 'icon',
        hidden: !getVertrag('json', vertrage),
        field: 'aktionsfahrzeug',
        i: 'aktionsfahrzeug',
        type: 'singleselect',
        data: sIntAktivStatus,
    },
    // mobile.de
    { title: 'Topinserat', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileTopinserat', i: 'mobileTopinserat', type: 'singleselect', data: sIntAktivStatus },
    { title: 'Blickfang', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileBlickfang', i: 'mobileBlickfang', type: 'singleselect', data: sIntAktivStatus },
    { title: 'Seite 1', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileSeiteEins', i: 'mobileSeiteEins', type: 'singleselect', data: sIntAktivStatus },
    { title: 'Rotstiftpr.', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileRotstiftpreis', i: 'mobileRotstiftpreis', type: 'singleselect', data: sIntAktivStatus },
    { title: 'Ad Turbo', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileAdTurbo', i: 'mobileAdTurbo', type: 'singleselect', data: sIntAktivStatus },
    { title: 'eBay Kleinanz.', group: 'mobile.de Verstärker', loading: 'icon', field: 'mobileEbayKleinanzeigen', i: 'mobileEbayKleinanzeigen', type: 'singleselect', data: sIntAktivStatus },
    // Tracking
    { title: 'Position', group: 'Tracking', loading: 'XS', field: 'tracking.pos.pos', i: 'trackingPosition', type: 'decimal', min: 0, customRender: true },
    { title: 'Aufrufe', group: 'Tracking', loading: 'XS', field: 'tracking.pos.impressions', i: 'trackingImpressions', type: 'decimal', min: 0 },
    { title: 'Parkungen', group: 'Tracking', loading: 'XS', field: 'tracking.pos.parkings', i: 'trackingParkings', type: 'decimal', min: 0 },
    { title: 'Anrufe', group: 'Tracking', loading: 'XS', field: 'tracking.pos.calls', i: 'trackingCalls', type: 'decimal', min: 0 },
    { title: 'Ausdrucke', group: 'Tracking', loading: 'XS', field: 'tracking.pos.prints', i: 'trackingPrints', type: 'decimal', min: 0 },
    { title: 'Mails', group: 'Tracking', loading: 'XS', field: 'tracking.pos.mails', i: 'trackingMails', type: 'decimal', min: 0 },
    // Preise
    { title: 'Steuer', group: 'Preise', loading: 'S', field: 'pr.vt', i: 'steuer', type: 'singleselect', data: sIntSteuer(getMwSt()) },
    { title: 'VK', group: 'Preise', loading: 'S', field: 'pr.bvkd', i: 'vk', type: 'currency' },
    { title: 'VK Web', group: 'Preise', loading: 'S', field: 'pr.vkinet', i: 'vkweb', type: 'currency' },
    { title: 'EK', group: 'Preise', loading: 'S', field: 'pr.bek', i: 'ek', type: 'currency' },
    { title: 'Ist-Kosten', group: 'Preise', loading: 'S', field: 'pr.kos', i: 'istKosten', type: 'currency', customRender: true },
    { title: 'Bruttoertrag', group: 'Preise', loading: 'S', field: 'pr.berg', i: 'bruttoertrag', customRender: true },
    { title: 'UPE', group: 'Preise', loading: 'S', field: 'pr.upe', i: 'upe', type: 'currency' },
    // Standzeit Eins
    { title: 'Zugang Reel', group: 'Statistik', loading: 'S', field: 'stat.zr', i: 'datumZugangReel', type: 'date' },
    { title: 'Eingangscheck', group: 'Statistik', loading: 'S', field: 'stat.ec', i: 'datumEingangscheck', type: 'date' },
    { title: 'In TÜV', group: 'Statistik', loading: 'S', field: 'stat.tuv', i: 'datumInTÜV', type: 'date' },
    { title: 'TÜV Ok', group: 'Statistik', loading: 'S', field: 'stat.tuvok', i: 'datumTÜVOK', type: 'date' },
    { title: 'In W&V', group: 'Statistik', loading: 'S', field: 'stat.wv', i: 'datumWV', type: 'date' },
    { title: 'W&V Ok', group: 'Statistik', loading: 'S', field: 'stat.wvok', i: 'datumWVOK', type: 'date' },
    { title: 'In Werkstatt', group: 'Statistik', loading: 'S', field: 'stat.w', i: 'datumInWerkstatt', type: 'date' },
    { title: 'Technik Ok', group: 'Statistik', loading: 'S', field: 'stat.wok', i: 'datumTechnikOK', type: 'date' },
    { title: 'In Werkstatt Extern', group: 'Statistik', loading: 'S', field: 'stat.we', i: 'datumInWerkstattExtern', type: 'date' },
    { title: 'Technik Extern Ok', group: 'Statistik', loading: 'S', field: 'stat.weok', i: 'datumTechnikExternOK', type: 'date' },
    { title: 'In Lack', group: 'Statistik', loading: 'S', field: 'stat.l', i: 'datumInLack', type: 'date' },
    { title: 'Lack Ok', group: 'Statistik', loading: 'S', field: 'stat.lok', i: 'datumLackOK', type: 'date' },
    { title: 'In Aufbereitung', group: 'Statistik', loading: 'S', field: 'stat.a', i: 'datumInAufbereitung', type: 'date' },
    { title: 'Optik Ok', group: 'Statistik', loading: 'S', field: 'stat.aok', i: 'datumOptikOK', type: 'date' },
    { title: 'Verkaufsfertig', group: 'Statistik', loading: 'S', field: 'stat.vkf', i: 'datumVerkaufsfertig', type: 'date' },
];

export default sSpaltenFahrzeuglisteOld;
